import React from 'react'
import { Link } from 'react-router-dom'
import Logo from './Logo'
import EnabledVerticalMenuIcon from './EnabledVerticalMenuIcon'
import DisabledVerticalMenuIcon from './DisabledVerticalMenuIcon'
import Disconnection from './Disconnection'
import RedirectToHome from './RedirectToHome'
import enabledTodayIcon from '../images/enabledTodayIcon.svg'
import disabledTodayIcon from '../images/disabledTodayIcon.svg'
import enabledVerticalEventIcon from '../images/enabledVerticalEventIcon.svg'
import disabledVerticalEventIcon from '../images/disabledVerticalEventIcon.svg'
import enabledVerticalTicketIcon from '../images/enabledVerticalTicketIcon.svg'
import disabledTicketIcon from '../images/disabledTicketIcon.svg'
import disabledDisconnectionIcon from '../images/disabledDisconnectionIcon.svg'
import redirectToPiIcon from '../images/redirectToPiIcon.svg'
import config from '../config'

class VerticalMenuComponent extends React.Component {
  checkTodayTab () {
    if (this.props.enabled === 'today') {
      return (
        <EnabledVerticalMenuIcon
          img={enabledTodayIcon}
          label="Aujourd'hui"
        />
      )
    }
    return (
      <DisabledVerticalMenuIcon
        img={disabledTodayIcon}
        label="Aujourd'hui"
      />
    )
  }

  checkEventTab () {
    if (this.props.enabled === 'event') {
      return (
        <EnabledVerticalMenuIcon
          img={enabledVerticalEventIcon}
          label='Evénements'
        />
      )
    }
    return (
      <DisabledVerticalMenuIcon
        img={disabledVerticalEventIcon}
        label='Evénements'
      />
    )
  }

  checkTicketTab () {
    if (this.props.enabled === 'ticket') {
      return (
        <EnabledVerticalMenuIcon
          img={enabledVerticalTicketIcon}
          label='Tickets'
        />
      )
    }
    return (
      <DisabledVerticalMenuIcon
        img={disabledTicketIcon}
        label='Tickets'
      />
    )
  }

  checkDisconnectionTab () {
    return (
      <Disconnection
        img={disabledDisconnectionIcon}
        label='Déconnexion'
        onClick={() => this.disconnect()}
      />
    )
  }

  disconnect () {
    var token = localStorage.getItem('token')
    fetch(`${config.salt_url}/oauth/revoke?client_id=${config.clientId}&token=${token}`, { method: 'post' })
      .then(response => response.json())
      .then(data => {
        localStorage.clear()
        window.location.replace(`${config.salt_url}/users/log_out`)
      })
      .catch(error => console.error('error ', error))
  }

  render () {
    return (
      <div>
        <Logo />
        <Link style={styles.link} to='dashboard'>
          {this.checkTodayTab()}
        </Link>
        <Link style={styles.link} to='events'>
          {this.checkEventTab()}
        </Link>
        <Link style={styles.link} to='tickets'>
          {this.checkTicketTab()}
        </Link>
        {this.checkDisconnectionTab()}
        <RedirectToHome
          img={redirectToPiIcon}
          onClick={() => { document.location.href = config.salt_url }}
        />
      </div>
    )
  }
}

const styles = {
  link: {
    textDecoration: 'none'
  }
}

export default VerticalMenuComponent
